"use client"

import { Skeleton } from "@/components/ui/skeleton"
import { NotificationListSkeletonProps } from "@/types/types"

export function NotificationListSkeleton({ className = "" }: NotificationListSkeletonProps) {
  return (
    <div className={className}>
      <div className="container mx-auto px-4 py-8 lg:py-12">
        <div className="flex items-center justify-between pb-3 sm:pb-1">
          <Skeleton className="h-7 w-32 rounded" />
          <Skeleton className="h-5 w-20 rounded" />
        </div>

        <div className="grid grid-cols-2 gap-6 sm:gap-0">
          {Array.from({ length: 4 }).map((_, index) => (
            <div key={index} className="flex flex-col">
              <Skeleton className="w-full pb-[75%] rounded-md mb-3" />
              <Skeleton className="h-4 w-11/12 rounded mb-2" />
              <Skeleton className="h-3 w-10/12 rounded" />
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
